const news1 = {
  title:
    "Delauney's Traffic Simulation Software Empowers Singapore's Smart Innovation",
  date: "2025-04-07",
  type: "1",
  content:
    "<p>On April 7, 2025, the Land Transport Authority (LTA) of Singapore held a grand opening ceremony for its 'Road Innovation Laboratory.' Jiangsu Delauney's independently developed AIRoad-VRRoad integrated design and simulation software was invited to join the laboratory, collaborating with industry organizations, academic institutions, and enterprises to jointly empower road innovation in Singapore.<br/></p>\n" +
    "<br/>\n" +
    "<figure>\n" +
    '<img src="/static/images/news/news1/picture1.png"/>\n' +
    "<figcaption>Singapore LTA Road Innovation Laboratory Inauguration Ceremony</figcaption>\n" +
    "</figure>\n" +
    "<br/>\n" +
    "<p>During the event, Mr. Lau Peet Meng, Permanent Secretary of Singapore's Ministry of Transport, and Mr. Ng Lang, CEO of LTA, attended the presentation by the Delauney team and experienced the driving simulation based on Singapore's urban roads. They expressed high recognition and appreciation for the solution. The project leverages Delauney's AIRoad Road Engineering Schematic Design System to successfully construct a high-precision 3D model incorporating road alignment, traffic facilities, and surrounding environments. This enables a fully digital closed-loop process—from road engineering design and visual guidance effects to microscopic traffic simulation and safety evaluation.</p>\n" +
    "    <br/>\n" +
    "<figure>\n" +
    '<img src="/static/images/news/news1/picture2.png"/>\n' +
    "<figcaption>Introducing Delauney's Software Application Cases to Mr. Lau Peet Meng, Permanent Secretary of Singapore's Ministry of Transport\n" +
    "</figcaption>\n" +
    "</figure>\n" +
    "    <br/>\n" +
    "    <br/>\n" +
    "<figure>\n" +
    '<img src="/static/images/news/news1/picture3.png"/>\n' +
    "<figcaption>Mr. Lau Peet Meng Experiencing the VRRoad Driving Simulator</figcaption>\n" +
    "</figure>\n" +
    "<br/>\n" +
    "<h2>\n" +
    "    Technical Review<br/> ·Data Extraction\n" +
    "</h2>\n" +
    "    <br/>\n" +
    "    <br/>\n" +
    "<figure>\n" +
    '    <img src="/static/images/news/news1/picture4.png"/>\n' +
    "    <figcaption>Extracting road design elements from CAD drawings</figcaption>\n" +
    "</figure>\n" +
    "    <br/>\n" +
    "<h2>\n" +
    "    ·Data Integration\n" +
    "</h2>\n" +
    "    <br/>\n" +
    "    <br/>\n" +
    "<figure>\n" +
    '    <img src="/static/images/news/news1/picture5.png"/>\n' +
    "    <figcaption>Merging road design elements with oblique photography files in AIRoad to build a high-precision 3D model. The BIM core model is constructed based on CAD data, ensuring zero-loss conversion of design parameters.\n" +
    "    </figcaption>\n" +
    "</figure>\n" +
    "    <br/>\n" +
    "<h2>\n" +
    "    ·Scene Construction\n" +
    "</h2>\n" +
    "    <br/>\n" +
    "    <br/>\n" +
    "<figure>\n" +
    '    <img src="/static/images/news/news1/picture6.png"/>\n' +
    "    <figcaption>Optimizing the model in VRRoad's scene editor and integrating BIM with GIS. The intelligent scene engine enables dynamic lighting, traffic flow simulation, and realistic environment rendering.\n" +
    "    </figcaption>\n" +
    "</figure>\n" +
    "    <br/>\n" +
    "<h2>\n" +
    "    ·Simulation Verification\n" +
    "</h2>\n" +
    "    <br/>\n" +
    "    <br/>\n" +
    "<figure>\n" +
    '    <img src="/static/images/news/news1/picture7.png"/>\n' +
    "    <figcaption>Importing the scene into VRRoad for driving simulation validation.\n" +
    "    </figcaption>\n" +
    "</figure>\n" +
    "    <br/>\n" +
    "<h2>\n" +
    "    ·Data Analysis\n" +
    "</h2>\n" +
    "    <br/>\n" +
    "    <br/>\n" +
    "<figure>\n" +
    '    <img src="/static/images/news/news1/picture8.png"/>\n' +
    "    <figcaption>Generating 85 safety evaluation indicators through the VRRoad driving simulation system, including conflict point analysis, sight distance verification, and other professional data.\n" +
    "    </figcaption>\n" +
    "</figure>\n" +
    "    <br/>\n" +
    "    <br/>\n" +
    "<h2>Conclusion and Outlook</h2>\n" +
    "<p>\n" +
    "    Under the CDG’s strategic vision of 'Digitalization, Industrialization, Platformization, and Internationalization,' Delauney is accelerating the development of an intelligent transportation 'product + service' network covering the Belt and Road initiative. Delauney is actively promoting mutual recognition of international standards and data interoperability to provide more global clients with scalable and replicable digital road innovation solutions.\n" +
    "    <br/>\n" +
    "    <br/>\n" +
    "    'Connect The World, Make City More Livable.' As a pioneer in China's intelligent transportation technology going global, Delauney is deepening technical collaboration with overseas industry institutions and partners. The company is committed to integrating self-developed technology system with the digital needs of different regions, delivering innovative solutions across borders to build safer and more efficient transportation infrastructure worldwide.\n" +
    "</p>",
};

const news2 = {
  title: "Delauney Visits Hanoi, Vietnam for Exchange and Cooperation",
  date: "2025-03-23",
  type: "1",
  content:
    "<p>\n" +
    "    From March 18 to 22, 2025, Delauney General Manager Mr. Xiao Bin and International Business Manager Mr. Zhang Yipin\n" +
    "    visited Hanoi, Vietnam, to participate in a technical exchange event on digital infrastructure design and\n" +
    "    intelligent construction. During the visit, the delegation held meetings and discussions with several companies\n" +
    "    including Trung Chinh, Baezeni, HED, and ZWSOFT Vietnam, and also visited the Hanoi University of Civil Engineering\n" +
    "    (HUCE).\n" +
    "</p>\n" +
    "<br/>\n" +
    "<br/>\n" +
    "<p>The trip aimed to further explore market opportunities for Vietnam's infrastructure digitalization, advance\n" +
    "    cooperation in infrastructure project management platforms, smart construction sites, and consulting services, and\n" +
    "    accelerate the localization of Delauney's software products in Vietnam. This marks the entry of Delauney's digital\n" +
    "    software and smart hardware products into the Vietnamese market.\n" +
    "</p>\n" +
    "<br/>\n" +
    "<br/>\n" +
    "<figure>\n" +
    "    <img src='/static/images/news/news2/picture1.png'/>\n" +
    "    <figcaption>Photo: Collaborative Partnership | With the Head of Trung Chinh R&D Center</figcaption>\n" +
    "</figure>\n" +
    "<br/>\n" +
    "<br/>\n" +
    "<p>\n" +
    "    Trung Chinh is a leading bridge construction company in Vietnam, with business covering highways, tunnels, waterway\n" +
    "    transportation, as well as EPC projects and industrial investment. The company currently has over 1,400 employees.\n" +
    "    It has maintained rapid growth in recent years. Mr. Nguyen Van Manh, Director of Trung Chinh's High-Tech R&D and\n" +
    "    Application Center, stated that the company's leadership places great emphasis on digital transformation and has\n" +
    "    observed the remarkable progress of many Chinese enterprises in this regard. Moving forward, Trung Chinh will\n" +
    "    collaborate with China Design Group and Delauney in foundational software platforms, project management\n" +
    "    technologies, consulting, and training to support digital talent development and achieve comprehensive digital\n" +
    "    transformation in technology, operations, and management.\n" +
    "</p>\n" +
    "<br/>\n" +
    "<br/>\n" +
    "<figure>\n" +
    "    <img src='/static/images/news/news2/picture2.png'/>\n" +
    "    <figcaption>Photo: Collaborative Partnership | With Baezeni Vietnam's Co-Founder</figcaption>\n" +
    "</figure>\n" +
    "<br/>\n" +
    "<br/>\n" +
    "<figure>\n" +
    "    <img src='/static/images/news/news2/picture3.png'/>\n" +
    "    <figcaption>Photo: Baezeni Vietnam's Technical Engineers Testing Delauney AIRoad 2025 International Edition\n" +
    "    </figcaption>\n" +
    "</figure>\n" +
    "<br/>\n" +
    "<br/>\n" +
    "<p>\n" +
    "    Baezeni specializes in providing BIM modeling and digital reconstruction services for in-service infrastructure to\n" +
    "    clients in Europe, the Middle East, and North America. It is also a major partner and distributor of ZWCAD in\n" +
    "    Vietnam's construction industry, with branches in Indonesia and Thailand. Baezeni plans to integrate Delauney's\n" +
    "    digital design software into its workflow and undertake localized development for Vietnam. The company is currently\n" +
    "    conducting comprehensive tests on Delauney AIRoad International Edition and has begun preliminary development and\n" +
    "    testing of the AIRoad SDK for secondary development.\n" +
    "</p>\n" +
    "<br/>\n" +
    "<br/>\n" +
    "<figure>\n" +
    "    <img src='/static/images/news/news2/picture4.png'/>\n" +
    "    <figcaption>Photo: Visiting Hanoi University of Civil Engineering (HUCE)\n" +
    "    </figcaption>\n" +
    "</figure>\n" +
    "<br/>\n" +
    "<br/>\n" +
    "<p>\n" +
    "    During the event, Delauney General Manager Mr. Xiao Bin visited HUCE and met with the university's Vice President, International Liaison Office, Dean of the Road and Bridge Faculty, Professor. Gao Fuqiang, and Professor. Le Nam Phong. HUCE is one of Vietnam's leading higher education institutions in civil engineering. Mr. Xiao Bin introduced Delauney's solutions and progress in 'digital transportation industry-education integration' with Chinese universities. Both parties discussed potential collaborations in academic software, joint training for international students, and research services.\n" +
    "</p>",
};

const news3 = {
  title:
    "Delauney’s Digital Intelligence Products Go Global SITCE 2024 International Intelligent Transportation Exhibition",
  date: "2024-11-09",
  type: "1",
  content:
    "<p>\n" +
    "    November 6–8, 2024, Delauney participated in the 5th Singapore International Transport Congress and Exhibition\n" +
    "    (SITCE 2024). This initiative aimed to explore international market opportunities for industrial startups, marking\n" +
    "    the beginning of Delauney's digital software and intelligent hardware products venturing into the global market.\n" +
    "</p>\n" +
    "<br/>\n" +
    "<br/>\n" +
    "<img src='/static/images/news/news3/picture1.png'/>\n" +
    "<br/>\n" +
    "<br/>\n" +
    "<h2>\n" +
    "    150+ Global Exhibitors | 6,000+ Attendees\n" +
    "</h2>\n" +
    "<p>\n" +
    "    SITCE 2024, co-organized by the International Association of Public Transport (UITP), Singapore's Land Transport\n" +
    "    Authority (LTA), and MSI Global Pte Ltd, is the largest and most influential transportation technology exhibition in\n" +
    "    the Asia-Pacific region. This year's event showcased cutting-edge smart transportation innovations, fostering\n" +
    "    industry collaboration and development. It attracted over 150 global exhibitors and more than 6,000 Attendees.\n" +
    "</p>\n" +
    "<br/>\n" +
    "<br/>\n" +
    "<img src='/static/images/news/news3/picture2.png'/>\n" +
    "<br/>\n" +
    "<br/>\n" +
    "<h2>\n" +
    "    Delauney's Booth Welcomed Hundreds of Overseas Clients!\n" +
    "</h2>\n" +
    "<p>\n" +
    "    The Delauney booth hosted numerous government agencies, transportation construction and operation companies, and\n" +
    "    potential partners from Southeast Asia, the Middle East, and Europe. Among them, 75% were from Singapore, with\n" +
    "    others from Malaysia, Indonesia, Saudi Arabia, the UAE, Denmark, and Kazakhstan, laying a solid foundation for\n" +
    "    Delauney and Opendrive Technology's expansion in Asian and international markets.\n" +
    "</p>\n" +
    "<br/>\n" +
    "<br/>\n" +
    "<figure>\n" +
    "    <img src='/static/images/news/news3/picture3.png'/>\n" +
    "    <figcaption>Introducing Zikun Digital Design Products to Indonesian Clients\n" +
    "    </figcaption>\n" +
    "</figure>\n" +
    "<br/>\n" +
    "<br/>\n" +
    "<figure>\n" +
    "    <img src='/static/images/news/news3/picture4.png'/>\n" +
    "    <figcaption>Presenting Smart Construction and Smart Site Solutions to Middle Eastern Clients\n" +
    "    </figcaption>\n" +
    "</figure>\n" +
    "<br/>\n" +
    "<br/>\n" +
    "<p>\n" +
    "    During the exhibition, CDG’s Vice President Mr. Xu Yigang ed the Delauney team on visits to Singapore's CPG Group,\n" +
    "    ST Engineering, and Shanghai Harbour Singapore Branch, engaging in fruitful discussions with local design and\n" +
    "    construction leaders. These exchanges provided valuable insights into international market strategies from Chinese\n" +
    "    enterprises expanding overseas.\n" +
    "</p>\n" +
    "<br/>\n" +
    "<br/>\n" +
    "<img src='/static/images/news/news3/picture5.png'/>\n" +
    "<br/>\n" +
    "<br/>\n" +
    "<p>\n" +
    "    Jiangsu Delauney is committed to integrating global expertise to shape the future of transportation and urban development. Actively advancing its digital, industrial, platform-based, and internationalization strategies, the company continues to achieve innovative breakthroughs through global collaboration. This exhibition not only showcased Delauney's latest achievements in intelligent software and hardware but also highlighted its vision of promoting sustainable transportation and urban development from a global perspective.\n" +
    "</p>",
};
export { news1, news2, news3 };
